import React from "react";

export default function Skeleton() {
  return (
    <div className="filter-skeleton">
      <div className="filter-skeleton-title"></div>
      <div className="filter-skeleton-list">
        {[1, 2, 3, 4, 5].map(() => (
          <div className="filter-skeleton-item"></div>
        ))}
      </div>
      <div className="filter-skeleton-list">
        {[1, 2, 3, 4, 5].map(() => (
          <div className="filter-skeleton-item"></div>
        ))}
      </div>
    </div>
  );
}
